<template>
    <footer class="footer">
        <div class="content">
            <div class="top">
                <div class="left">
                    <div class="col">
                        <div class="title">
                            {{footerData.row1?.title}}
                        </div>

                        <div
                            class="row"
                            v-for="(item ,index) in footerData.row1.list"
                            :key="index"
                        >
                            <a :href="item.url">{{item.name}}</a>
                        </div>

                    </div>

                    <div class="col">
                        <div class="title">
                            {{footerData.row2.title}}
                        </div>

                        <div
                            class="row"
                            v-for="(item ,index) in footerData.row2.list"
                            :key="index"
                        >
                            {{item}}
                        </div>
                    </div>
                </div>

                <div class="right">
                    <div class="list">

                        <div
                            class="item"
                            v-for="(item,index) in footerData.QRCodeList"
                            :key="index"
                        >
                            <div class="qrcode">
                                <img
                                    height="86"
                                    width="86"
                                    :src="item.url"
                                >
                            </div>

                            <div class="name">
                                {{item.name}}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="bottom">
                <div class="item">
                    版权声明
                </div>
                <a
                    class="item"
                    :href="footerData.companyUrl || '#'"
                >{{footerData.company}}</a>
                <a
                    class="item"
                    :href="footerData.ICPUrl || '#'"
                >{{footerData.ICP}}</a>
                <a
                    class="item"
                    :href="footerData.copyrightUrl || '#'"
                >{{footerData.copyright}}</a>

                <cnzz></cnzz>
            </div>
        </div>
    </footer>
</template>


<script>
export default {
    // inject: ['webInfo'],
    computed: {
        footerData(){
            return this.webInfo.footer || {};
        },
    },
    watch: {},
    data() {
        return {
            
        };
    },
    methods: {},
    mounted: function () {
    },
};
</script>


<style lang="scss" scoped>
.footer {
    background: #2f354d;
    color: white;
    padding: 37px 0 27px;

    a {
        color: white;
    }

    .content {
        .top {
            display: flex;
            padding-bottom: 18px;

            .col {
                .title {
                    font-size: 18px;
                    margin-bottom: 22px;
                    cursor: default;
                }

                .row {
                    & + .row {
                        margin-top: 16px;
                    }
                }

                & + .col {
                    margin-left: 186px;
                }
            }

            .list {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .item {
                    display: flex;
                    flex-flow: column;
                    align-items: center;
                    margin-bottom: 30px;

                    .qrcode {
                        width: 110px;
                        height: 110px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .name {
                        line-height: 1em;
                        margin-top: 10px;
                    }
                }
            }
        }

        .bottom {
            display: flex;
            padding-top: 22px;
            position: relative;
            justify-content: center;

            .item {
                & + .item {
                    margin-left: 0.5em;
                }
            }

            &::before {
                content: '';
                display: block;
                width: 100%;
                height: 1px;
                background: #979797;
                position: absolute;
                top: 0;
                left: 0;
            }
        }

        .left {
            display: flex;
            flex: 1;
        }

        .right {
        }
    }
}
</style>

